"use strict";

var _gatsbyLink = require("gatsby-link");

var _catchLinks = require("./catch-links");

var _catchLinks2 = _interopRequireDefault(_catchLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onClientEntry = function () {
  (0, _catchLinks2.default)(window, function (href) {
    (0, _gatsbyLink.navigateTo)(href);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-catch-links/gatsby-browser.js
// module id = 372
// module chunks = 231608221292675